import { useStaticQuery, graphql } from 'gatsby'
import React, { useEffect } from 'react'
import { GTMScript } from './gtm'
import { useLocation } from '@reach/router'

const Seo = (props) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          siteUrl
          description
          ogpImage
        }
      }
    }
  `)
  useEffect(() => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({ event: 'optimize.activate' })
  }, [])

  const location = useLocation()
  // FIXME: location.originで動的にoriginを取得するとgatsby develop時以外のstgや本番環境でundefinedになるためsiteMetadata.siteUrlを使用
  const url = location.pathname ? `${data.site.siteMetadata.siteUrl}${location.pathname}` : `${data.site.siteMetadata.siteUrl}`
  const metaSiteName = data.site.siteMetadata.title
  // pagetitle内の半角パイプ(|)を全角パイプ(｜)に変換
  const normalizedPageTitle = props.pagetitle ? props.pagetitle.replace(/\|/g, '｜') : null
  const metaTitle = normalizedPageTitle ? `${normalizedPageTitle}｜株式会社メイツ` : metaSiteName
  const metaDescription = props.description || data.site.siteMetadata.description
  const metaImage = props.image || `${data.site.siteMetadata.siteUrl}${data.site.siteMetadata.ogpImage}`
  const pageType = props.pageType || 'website'
  const preloadImage = props.preloadImage

  // 本番環境かどうかを判定
  const isProduction = process.env.GATSBY_STATS === 'production'

  // noIndexがtrueの場合はnoindexを設定
  const noIndex = props.noIndex

  // pathnameがexcludePathsに含まれていない場合のみPtengineのスクリプトを追加
  const excludePaths = ['/aim/blog', '/category/aim']
  const addPtengineScript = !excludePaths.some((path) => location.pathname.startsWith(path))

  // Contentfulの画像CDNへ接続を先に張るページ。ビルド出力363件を走査して決めた3件で、
  // images.ctfassets.netを参照する265ページを取りこぼしなく覆う（#757）。
  // 前方一致なので画像を持たない31ページ（/aim/blogTheme/ や /aim/seminar-thanks/ など）にも出る（#766で実測）
  const contentfulImagePaths = ['/aim/blog', '/aim/seminar', '/news/aim']
  const preconnectContentfulImages = contentfulImagePaths.some((path) => location.pathname.startsWith(path))

  return (
    <>
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="image" content={metaImage} />
      <link rel="canonical" href={url} />
      {isProduction ? <meta name="robots" content={noIndex ? 'noindex' : 'index'} /> : <meta name="robots" content="noindex" />}
      <link rel="icon" href={'/aim/favicon.ico'} />
      <link rel="apple-touch-icon" href={'/aim/favicon.ico'} />
      {preconnectContentfulImages && <link rel="preconnect" href="https://images.ctfassets.net" />}
      {preloadImage &&
        (Array.isArray(preloadImage)
          ? preloadImage.map((img, i) =>
              img?.sources?.map(
                (source, j) =>
                  source?.type === 'image/webp' && (
                    <link rel="preload" imageSrcSet={source?.srcSet} imageSizes={source?.sizes} media={source?.media} as="image" fetchpriority="high" key={`${i}-${j}`} />
                  )
              )
            )
          : preloadImage.sources?.map(
              (source, index) =>
                source?.type === 'image/webp' && (
                  <link rel="preload" imageSrcSet={source?.srcSet} imageSizes={source?.sizes} media={source?.media} as="image" fetchpriority="high" key={index} />
                )
            ))}

      {/* facebook */}
      <meta name="facebook-domain-verification" content="dsabf632j2l6u17ibdnjqtxv3zyiq3" />

      {/* ogp */}
      <meta property="og:site_name" content={metaSiteName} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={pageType} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />

      {/* Ptengine。アンチフリッカーのロジックは基本タグに入っているため専用タグは置かない（#736）。
          async / defer も付けない — 非同期にすると実行が遅れてアンチフリッカーが機能しなくなる */}
      {addPtengineScript && isProduction && <script src="https://js.ptengine.jp/77otm6ua.js"></script>}

      {/* google tag manager */}
      <GTMScript />
    </>
  )
}
export default Seo
